export default __webpack_public_path__ + "static/media/Bloodedge.e2a778aa.jpg";